import React, { useEffect, useState } from "react";
import ColumnComponent from "../../ColumnComponent/ColumnComponent";
import OrderBox from "../../OrderBoxV2/OrderBoxV2";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store";
import PerfectScrollbar from "react-perfect-scrollbar";
import OrderDriverBox from "../../OrderDriverBox/OrderDriverBox";
import { CnCOrderResponse } from "../../../../types/api";

type Props = {
  isAdmin?: boolean;
  isDriver?: boolean;
  title?: string;
};
const ProcessedColumn = ({ isAdmin, isDriver, title }: Props) => {
  const orderState = useSelector((state: RootState) => state.order);

  // Update state type to be more specific
  const [orders, setOrders] = useState<JSX.Element[] | JSX.Element>(
    <div>Waiting...</div>
  );

  useEffect(() => {
    if (!orderState.loadingOrders) {
      if (orderState.ordersFailed) {
        //     tODO ovde prikaz ako se desila greska prilikom ucitavanja porudzbina
        setOrders(<div>Greška prilikom učitavanja porudžbina</div>);
      } else {
        if (orderState.processedOrders.length > 0) {
          setOrders(
            orderState.processedOrders.map(
              (order: CnCOrderResponse, index: number) => {
                return isDriver ? (
                  <OrderDriverBox
                    processed={true}
                    key={order.id}
                    order={order}
                  />
                ) : (
                  <OrderBox
                    processed={true}
                    isDriver={isDriver}
                    key={order.id}
                    order={order}
                    isAdmin={isAdmin}
                  />
                );
              }
            )
          );
        } else {
          setOrders(<div>Nema obrađenih porudžbina</div>);
        }
      }
    }
  }, [
    orderState.processedOrders,
    orderState.loadingOrders,
    orderState.ordersFailed,
    isAdmin,
    isDriver,
  ]);
  return (
    <ColumnComponent
      leftSideLabel={title || ""}
      leftSideNumber={orderState.processedOrders.length.toString()}
      style={{ flex: "4" }}
    >
      <PerfectScrollbar style={{ padding: "4px" }}>{orders}</PerfectScrollbar>
    </ColumnComponent>
  );
};

export default ProcessedColumn;
